
import { environment } from '../../../../environments/environment';
export const site = {
    website: environment.website,
    displayWebsite: environment.displayWebsite,
    email: environment.email,
    apiHost: environment.apiHost,
    customerUrl: environment.customerUrl,
    displayCusUrl: environment.displayCusUrl
};

export const spekwo = {
    prouct1: 'HIQFULL',
    prouct2: 'INSPECTIONCALL',
    prouct3: 'GCCONSULTING',
    prouct4: 'CGPYWCK',
    prouct5: 'RJCZPSJ',

    phoneNumber: 'O. 704-622-3326',
    phone: '0.866.646.0200',
    website: site.website,
    displayWebsite: site.displayWebsite,
    customerUrl: site.customerUrl,
    displayCusUrl: site.displayCusUrl,
    logoUrlHome: 'assets/images/logos/speKwo_logo.png',
    logoUrl: 'assets/images/logos/spekwo1.png',
    logoUrl1: 'assets/images/logos/logo-image.png',
    solutionEstimateUrl: 'assets/images/Main Screen/home inspection.jpg',
    customizeSolutionUrl: 'assets/images/Main Screen/customize.jpg',
    requestWorkUrl: 'assets/images/Main Screen/solutions.jpg',
    headerurl:'assets/images/Main Screen/header.jpg',

    spekWalk: 'SpeK-Walk Summary Review',
    spekCall: 'SpeK-Call Summary Review',
    'All Users': 'All Users',
    Owner: 'Owner',
    'Solution Estimate': 'Solution Estimate',
    'speK ExeC': 'speK ExeC',
    'Senior Estimator': 'Senior Estimator',
    'Estimator': 'Estimator',
    'Spekwo Manager': 'Inspect Quote Manager',
    'Pro': 'Pro',
    'HIQFULL': 'Full Spekwo',
    'GCCONSULTING': 'Walk and Talk',
    'INSPECTIONCALL': 'SpeK - Call ',
    'RJCZPSJ': 'The Pre-List speK-Sheet',
    'CGPYWCK': 'Specific Item speKwo',
    'Seller': 'Seller',
    'Seller Agent': 'Seller Agent',
    'Buyer Agent': 'Buyer Agent',
    'Buyer': 'Buyer',
    defaultUrl: 'assets/images/avatars/profile.jpg',
    productImg: 'assets/images/ecommerce/product-image-placeholder.png',
    totalCost: 'Total Cost'
};

export const checkoutFields = {
    buyerProperty: 'billing_myfield2',
    agentRole: 'billing_myfield1',
    clientRole: 'billing_myfield15',
    solutionEmail: 'billing_myfield24',
    clientName: 'billing_myfield23',
    cartPageDetails: '_tmcartepo_data',
    'deliveryTime': 'Delivery Time',
    'apptDate': 'myfield2',//spekcall & walktalk

    // php values
    status: 'status',
    success: 'success',
    noRecords: 'No records found',
};

export const host = site.apiHost;

export const apiCalls = {
    singleOrder: host + 'orders.php',
    ordeAttachment: host + 'attachment.php',
    ocrDocumentUrl: host + 'uploads/',

    pdfFileFolder: host + 'solutionReports/',
    pdfFileName: 'solutionReport_',
    makePdf: host + 'makeSolutionPdf.php',

    sendRating: host + 'sendRatingToAdmin.php',
    attachToClient: host + 'attachmentToClient.php',
    sendApprovedNotifyToAdmin: host + 'afterClientReviewed.php',
    sendAlteredNotifyToAdmin: host + 'afterClientAltered.php',
    sendScheduleInfoToAdmin: host + 'afterClientReviewedSendEmailToAdmin.php',
    sendAlterScheduleInfoToAdmin: host + 'afterClientAlteredSendEmailToAdmin.php',
    ocrDocFetch: host + 'getOcrDocument.php',
};



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/utils/spekwo.ts